package com.anjuros.website.redesign.sections.designs

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.RdFaqBand
import com.anjuros.website.redesign.util.RdText

/** Questions and answers about the designs; also used for the FAQPage structured data. */
val DesignsFaqs = listOf(
    RdText.DESIGNS_FAQ1_Q to RdText.DESIGNS_FAQ1_A,
    RdText.DESIGNS_FAQ2_Q to RdText.DESIGNS_FAQ2_A,
    RdText.DESIGNS_FAQ3_Q to RdText.DESIGNS_FAQ3_A,
    RdText.DESIGNS_FAQ4_Q to RdText.DESIGNS_FAQ4_A,
    RdText.DESIGNS_FAQ5_Q to RdText.DESIGNS_FAQ5_A,
)

@Composable
fun DesignsFaqSection() {
    RdFaqBand(RdText.DESIGNS_FAQ_TITLE, DesignsFaqs)
}
